import React from "react";
import { Link, useLocation } from "react-router-dom";

const Header: React.FC = () => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <header className="w-full bg-white border-b border-[var(--uat-accent)] shadow-sm z-50">
      <div className="max-w-[90vw] mx-auto flex items-center justify-between md:justify-center md:gap-96 px-6 py-3">
        {/* IZQUIERDA */}
        <div className="flex items-center gap-4">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/uat.webp"
              alt="UAT"
              className="h-16 w-auto object-contain"
            />
          </Link>
        </div>

        <div className="hidden md:flex justify-center items-center w-1/3">
          <div className="hidden sm:block">
            <h1 className="text-lg font-semibold text-gray-800 leading-tight">
              Feria de Emprendedores UAT
            </h1>
            <p className="text-sm text-gray-500">
              {isAdmin ? "Panel de Administración" : "Registro de Expositores"}
            </p>
          </div>
        </div>

        {/* DERECHA */}
        <div className="flex items-center gap-6">
          <img
            src="/uamvh.webp"
            alt="Unidad académica"
            className="h-14 w-auto object-contain"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
